import React from "react";
import { Redirect } from "react-router-dom";
import { Alert, Row, Col, Form, Button } from "react-bootstrap";
import { fetchPsa, putPsa, postPsa, deletePsa } from "./services/DataService";
import DeleteAlert from "./components/DeleteAlert";
import "./style/form.scss";
import { datetimeToString } from "./services/UtilityService";
import DateTimePicker from "react-datetime-picker";

class AddPsa extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: "",
      name: " ",
      datetime: new Date(),
    };
    this.onStatusChange = this.onStatusChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.onDeleteCallback = this.onDeleteCallback.bind(this);
    this.submitCallback = this.submitCallback.bind(this);
  }

  componentDidMount() {
    if (this.props.match.params.id) {
      fetchPsa(this.props.match.params.id).then((psa) => {
        var datetime = new Date(psa.datetime.replace("Z", ""));
        this.setState({ ...psa, datetime: datetime });
      });
    }
  }

  onStatusChange(e) {
    this.setState({ status: e.target.value });
  }

  submitCallback() {
    this.setState({
      alert: (
        <Alert variant="secondary">
          <Alert.Heading>Submission Successful</Alert.Heading>
          <hr />
          <p>The psa has been added/updated.</p>
          <div className="d-flex justify-content-end">
            <Button
              onClick={() => this.setState({ redirect: "/psa" })}
              variant="outline-secondary"
            >
              Close
            </Button>
          </div>
        </Alert>
      ),
    });
  }

  handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;
    this.setState({ validated: true });
    var isValid = form.checkValidity();
    var psa = {};
    psa.id = parseInt(this.state.id);
    psa.organization = this.state.organization;
    psa.event = this.state.event;
    psa.datetime = datetimeToString(this.state.datetime);
    psa.location = this.state.location;
    psa.broadcast_phone = this.state.broadcast_phone;
    psa.contact_name = this.state.contact_name;
    psa.contact_phone = this.state.contact_phone;
    psa.contact_email = this.state.contact_email;
    psa.text = this.state.text;
    psa.broadcast = this.state.broadcast ?? false;
    if (isValid) {
      if (this.props.match.params.id) {
        putPsa(psa.id, psa).then(this.submitCallback);
      } else {
        postPsa(psa).then(this.submitCallback);
      }
    }
  };

  onDelete() {
    this.setState({ deleteAlert: true });
  }

  onDeleteCallback() {
    this.setState({ deleteAlert: false, redirect: "/psa" });
  }

  onChange = (e) => this.setState({ [e.target.name]: !e.target.value });

  render() {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />;
    }
    if (this.state.alert) {
      return this.state.alert;
    }
    let deleteAlert;
    if (this.state.deleteAlert) {
      deleteAlert = (
        <DeleteAlert
          onConfirm={() => {
            deletePsa(this.state.id).then(this.onDeleteCallback);
          }}
          onCancel={() => this.setState({ deleteAlert: false })}
        />
      );
    }
    let deleteButton;
    if (this.props.match.params.id) {
      deleteButton = (
        <div className="d-flex justify-content-center">
          <Button
            variant="danger"
            className="btn-delete"
            onClick={this.onDelete}
          >
            Delete
          </Button>
        </div>
      );
    }
    const dataType = [
      "organization",
      "event",
      "location",
      "broadcast_phone",
      "contact_name",
      "contact_phone",
      "contact_email",
      "text",
    ];
    const formdata = dataType.map((data) => (
      <Row key={data}>
        <Form.Label
          column
          sm="3"
          className="d-flex align-items-center flex-row-reverse mb-2"
        >
          {data.charAt(0).toUpperCase() + data.substring(1).replace("_", " ")}
        </Form.Label>
        <Col sm="8">
          <Form.Control
            required
            name={
              data.charAt(0).toUpperCase() + data.substring(1).replace("_", " ")
            }
            onChange={(event) => this.setState({ [data]: event.target.value })}
            value={this.state[data] || ""}
            className="mb-0"
          />
          <Form.Control.Feedback type="invalid">
            Please provide a name for the PSA.
          </Form.Control.Feedback>
        </Col>
      </Row>
    ));
    return (
      <div>
        {deleteAlert}
        <div className="form-title">
          {this.props.match.params.id ? "Edit" : "Add"} a PSA
        </div>
        <Form
          className="form"
          noValidate
          validated={this.state.validated}
          onSubmit={this.handleSubmit}
        >
          {formdata}

          <Row>
            <Form.Label
              column
              sm="3"
              className="d-flex align-items-center flex-row-reverse  mb-2"
            >
              Start
            </Form.Label>
            <Col sm="8">
              <DateTimePicker
                showTimeSelect="false"
                className="form-control"
                value={this.state.datetime}
                onChange={(dt) => {
                  this.setState({ datetime: dt });
                }}
              />
            </Col>
          </Row>
          <div className="d-flex justify-content-center">
            <div style={{ width: "95px" }}></div>
            <Button variant="primary" type="submit" className="btn-submit">
              {this.props.match.params.id ? "Update" : "Add"}
            </Button>
            {deleteButton}
          </div>
        </Form>
      </div>
    );
  }
}

export default AddPsa;
